/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */
import { Action } from '@ngrx/store';
import * as actions from '../actions/experience.actions';
import { Experience } from '../../models/experience';

export interface ThresholdExperienceState {
    experiences: Experience[]
};

export const initialState: ThresholdExperienceState = {
    experiences: null
};

export function reducer(state = initialState, action: actions.Actions): ThresholdExperienceState {
    switch (action.type) {
        case actions.LOAD_EXPERIENCE:
            return {
                experiences: [...action.payload]
            };        
        default:
            return state;
    }
}

export const getExperiences = (state: ThresholdExperienceState) => state.experiences;


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/store/reducers/experience.reducer.ts